import React, { Component } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Grid, IconButton, withStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
// import OutlinedInput from '@material-ui/core/OutlinedInput';
import { EVENT_FOLDER } from '../constants';

const styles = (theme) => ({
  dialogRoot: {
    minHeight: '80vh',
    maxHeight: '94vh',
  },
  dialogActions: {
    display: 'none',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  closeBtnGrid: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  closeBtn: {
    position: 'absolute',
    right: '0px',
    // top: '10px',
    color: '#5b5b5b',
  },
  dialogContent: {
    padding: '30px',
  },
  posterTitle: {
    marginBottom: '15px',
  },
  posterTitleDiv: {
    fontSize: '15.5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  posterContentDiv: {
    paddingTop: '15px',
    borderTop: '1px solid rgba(1,1,1,0.2)',
  },
  posterContent: {
    maxWidth: '100%',
    height: 'auto',
    alignSelf: 'flex-start',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
      width: '100%',
    },
  },
});

class PosterDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noImg: false,
    };
  }

  changeNoImgState = () => {
    this.setState({ noImg: true });
  };

  render() {
    const { classes, open, onClose } = this.props;

    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          aria-labelledby="faq-dialog-title"
          open={open}
          onClose={onClose}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogContent className={classes.dialogContent}>
            <div className={classes.posterTitle}>
              <Grid container>
                <Grid item xs>
                  <span style={{ color: '#025a3c', fontWeight: 'bold', fontSize: 'large' }}>{this.props.regNo}</span>
                </Grid>
                <Grid item xs={9}>
                  <div className={classes.posterTitleDiv} style={{ color: '#000000', fontWeight: '500', marginBottom: '0.3em' }}>
                    {this.props.presenter}&nbsp;({this.props.position.replace('^&^', ',')},&nbsp;{this.props.country})
                  </div>
                  <div className={classes.posterTitleDiv} style={{ color: '#000000', fontWeight: 'bold' }}>
                    {this.props.ptTitle}
                  </div>
                </Grid>
                <Grid item xs className={classes.closeBtnGrid}>
                  <IconButton onClick={onClose} className={classes.closeBtn}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>

            <div className={classes.posterContentDiv}>
              {/*
              <div style={{ position: 'absolute', right: '100px', top: '5px' }}>
                <div style={{ width: '64px', height: '64px', overflow: 'hidden' }}>
                  <img src={this.props.posterImg} className={classes.posterContent} style={{ width: '100px' }} />
                </div>
              </div>
              
              */}

              <Grid container justifyContent="center" style={{ padding: '3vh 0', fontWeight: 'bold', fontSize: 'large', color: '#025a3c' }}>
                {this.state.noImg === false && '*You can zoom in/out the image by scrolling the mouse within the image area.'}
              </Grid>

              <Grid container justifyContent="center">
                <TransformWrapper
                  onZoomChange={(event) => {
                    // console.log(event);
                  }}
                  onPanning={(event) => {
                    // console.log(event);
                  }}
                >
                  <TransformComponent>
                    <img
                      src={`https://innon.s3.ap-northeast-2.amazonaws.com/${EVENT_FOLDER}/poster/${this.props.dept}.jpg`}
                      // src={`images/poster/${this.props.regNo}.jpg`}
                      className={classes.posterContent}
                      alt={''}
                      onError={this.changeNoImgState}
                    />
                  </TransformComponent>
                </TransformWrapper>
                {this.state.noImg === true ? (
                  <div style={{ padding: '10px 0', fontSize: 'large' }}>
                    {/* 포스터 이미지가 업로드될 예정입니다. */}A poster image will be uploaded.
                  </div>
                ) : (
                  ''
                )}

                {/*
                <Zoom>
                  <img src={this.props.posterImg} className={classes.posterContent} />
                </Zoom>
                */}
              </Grid>
            </div>
          </DialogContent>

          <DialogActions className={classes.dialogActions}>
            <div style={{ margin: '0 22px', borderTop: '1px solid rgba(1,1,1,0.2)' }}>
              <Button onClick={onClose} style={{ color: '#000000', fontSize: '18px', fontWeight: '600' }}>
                {/* 닫기 */}
                Close
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(PosterDialog);
